import { isLocale, LOCALE_COOKIE, LOCALE_COOKIE_MAX_AGE_SECONDS, type Locale } from '@/i18n/config'

/**
 * omnyqra: UI language (Omnyqra/sim#43), see FORK.md.
 *
 * The picked language lives only in this browser cookie; `null` means no choice,
 * so `Accept-Language` applies. Subscribable for `useSyncExternalStore`. After a
 * change the caller re-renders server components (`router.refresh()`), which
 * read the cookie in `i18n/request.ts`.
 */
const listeners = new Set<() => void>()

export function subscribeLocaleCookie(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function getLocaleCookie(): Locale | null {
  for (const part of document.cookie.split(';')) {
    const [name, value] = part.trim().split('=')
    if (name === LOCALE_COOKIE) return isLocale(value) ? value : null
  }
  return null
}

export function setLocaleCookie(locale: Locale | null): void {
  const secure = window.location.protocol === 'https:' ? '; Secure' : ''
  document.cookie =
    locale === null
      ? `${LOCALE_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${secure}`
      : `${LOCALE_COOKIE}=${locale}; Path=/; Max-Age=${LOCALE_COOKIE_MAX_AGE_SECONDS}; SameSite=Lax${secure}`
  for (const listener of listeners) listener()
}
